/**
 * package: com.inq.ui
 * class: VideoPlayer
 * @extends com.inq.ui.Container
 * @constructor
 */
com.inq.ui.VideoPlayer = function (id) {
	com.inq.ui.Container.call(this,id);
	/** @type {(com.inq.flash.client.chatskins.VideoPlayerScene7|object)} */
	this.pInst = null;
	/** @type {HTMLElement} */
	this.closeEl = null;
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.VideoPlayer, "com.inq.ui.VideoPlayer");

com.inq.ui.VideoPlayer.prototype.init = function () {
	this.pInst = com.inq.flash.client.chatskins.VideoPlayerBase.init(this.getStyle("type"));
	com.inq.flash.client.chatskins.VideoPlayerBase.loadExternalScript(this.getStyle("src"),this);

};

com.inq.ui.VideoPlayer.prototype.applyStyle = function () {
	com.inq.ui.Container.prototype.applyStyle.call(this);
	if (this.pInst === null) {
		this.init();
	}
};

/**
 * Handler of CLOSE event.
 * Can be called also by script command from agent and from the skin configuration.
 * @see: {@link com.inq.ui.Container.closeVideo}
 */
com.inq.ui.VideoPlayer.prototype.close = function () {
	this.pInst.close();
};

com.inq.ui.VideoPlayer.prototype.loadedScript = function () {
	this.pInst.setup(this);
};

com.inq.ui.VideoPlayer.prototype.play = function () {
	var els = null;
	/** @type {(com.inq.flash.client.chatskins.VideoPlayerScene7|object)} */
	var _pInst = this.pInst;
	if(com.inq.utils.Capabilities.isMobile()) {
		Application.application.getTextInput("txtInput").blur();
	}
	_pInst.play();

	if(!this.closeEl) {
		els = this._div.parentElement.querySelectorAll('div[id^="'+(this.pInst.isDivC()?'tcChat_':'')+'btnCloseVideo"]');
		if (els && els.length > 0) {
			this.closeEl = els[0];
			els[0].addEventListener('click',function(){
				_pInst.abandon();
			});
		}
	}

};

com.inq.ui.VideoPlayer.prototype.pause = function () {
	this.pInst.pause()
};

com.inq.ui.VideoPlayer.prototype.setupArgs = function (p) {
	this.pInst.clear();
	this.pInst.setup(this, p);
};

com.inq.ui.VideoPlayer.prototype.cleanUp = function () {
	this.pInst.clear();
};
